(() => {
  function initialize() {
    const output = document.querySelector('[data-hg-unit-price]');
    const form = document.querySelector('#product-form');
    const data = document.querySelector('[data-hg-unit-pricing]');
    if (!output || !form || !data || output.dataset.ready) return;
    const config = JSON.parse(data.textContent);
    const subtotal = document.querySelector('[data-hg-hat-subtotal]');
    const legacy = document.querySelector('#product-price');
    const format = cents => new Intl.NumberFormat(config.locale, {style:'currency',currency:config.currency}).format(cents / 100);
    let queued = false;
    function render() {
      queued = false;
      const id = form.querySelector('[name="id"]')?.value;
      const variant = config.variants.find(v => String(v.id) === id);
      if (!variant) return;
      const quantity = Math.max(1,Math.floor(Number(form.querySelector('#quantity')?.value) || 1));
      const tier = config.volumeEnabled && config.tiers.find(t => quantity >= t.min && (!t.max || quantity <= t.max));
      const unit = Math.round(variant.price * (1 - (tier ? tier.discount : 0) / 100));
      const compare = tier ? variant.price : variant.compare;
      output.querySelector('[data-unit-amount]').textContent = format(unit);
      const crossed = output.querySelector('[data-unit-compare]');
      crossed.hidden = !(compare > unit);
      crossed.textContent = compare > unit ? format(compare) : '';
      output.querySelector('[data-unit-quantity]').textContent = config.quantityText.replace('{count}',quantity);
      if (subtotal) {
        subtotal.querySelector('[data-subtotal-amount]').textContent = format(unit * quantity);
        subtotal.querySelector('[data-subtotal-detail]').textContent = `${quantity} × ${format(unit)} ${config.eachText}`;
      }
      output.dataset.unitCents = unit;
      if (subtotal) subtotal.dataset.totalCents = unit * quantity;
    }
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(render);
    }
    ['click','input','change'].forEach(type => form.addEventListener(type,schedule));
    document.addEventListener('variant:change',schedule);
    if (legacy) new MutationObserver(schedule).observe(legacy,{childList:true,subtree:true,characterData:true});
    const variantInput = form.querySelector('[name="id"]');
    if (variantInput) new MutationObserver(schedule).observe(variantInput,{attributes:true,attributeFilter:['value']});
    output.dataset.ready = 'true';
    render();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize); else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
